import cubejs from '@cubejs-client/core';
import { refreshTokenIfNeeded } from './cubejs';
const API_URL = `${import.meta.env.VITE_APP_CUBEJS_API}/cubejs/v1`;

const isTokenError = (err) => {
  if (!err) return false;
  const msg = (err?.response?.error || '')?.toLowerCase();
  if (msg?.includes('invalid jwt') || msg?.includes('jwt') || msg?.includes('token')) return true;
  return false;
};

const createCubeClient = (token) => cubejs(token, { apiUrl: API_URL });

export const loadWithRetry = async (query, options = {}) => {
  try {
    const CUBEJS_TOKEN = window.localStorage.getItem('cubejs_token');
    const client = createCubeClient(CUBEJS_TOKEN);
    return await client.load(query, options);
  } catch (err) {
    if (!isTokenError(err)) {
      throw err;
    }
    try {
      await refreshTokenIfNeeded();
      const CUBEJS_TOKEN = window.localStorage.getItem('cubejs_token');
      if (!CUBEJS_TOKEN) {
        throw new Error('Token refresh completed but no token found in storage');
      }
      const client = createCubeClient(CUBEJS_TOKEN);
      return await client?.load(query, options);
    } catch (refreshErr) {
      const e = refreshErr || err;
      throw e;
    }
  }
};

export const cubeApiWrapper = {
  load: (query, options) => loadWithRetry(query, options),
};
